import Icon from "@/components/Icon";
import { RadioOptionType, RadioTagGroup } from "@/components/Radio/RadioTag";
import { Center, chakra, FlexProps } from "@chakra-ui/react";
import { langStore, translate } from "@noli/business";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { ReactComponent as HotSvg } from "@/assets/icons/hot.svg";
import { genBlock } from "@/utils/bem";
import { PRESETS_TYPE_INFO, PresetTypes, PRESET_TYPES } from "@/modules/editor/constant";
import classNames from "classnames";
import { Editor_Words } from "@/utils/lang/editor";

const block = genBlock("c-presets-switch");
const IPresetSwitch: React.FC<{
  direction?: FlexProps["flexDirection"];
  enableModelTypes?: PresetTypes[];
  className?: string;
  value?: PresetTypes;
  onChange?: (value: PresetTypes) => void;
}> = ({ direction = "row", enableModelTypes = PRESET_TYPES, className, value, onChange }) => {
  const lang = langStore.tgt;

  const options = useMemo(() => {
    return enableModelTypes.map((type) => {
      const option: RadioOptionType = {
        value: PRESETS_TYPE_INFO[type].value,
        label: (
          <>
            {translate(PRESETS_TYPE_INFO[type]?.label, lang)}
            {PRESETS_TYPE_INFO[type]?.isHot ? (
              <Center h="14px">
                <Icon
                  squared={false}
                  w="60px"
                  h="64px"
                  p="6px"
                  transition="all .3s cubic-bezier(.08,.52,.52,1)"
                  mt="2px"
                  ml="-2px"
                  mr="-4px"
                  svg={HotSvg}
                />
              </Center>
            ) : null}
          </>
        ),
      };
      return option;
    });
  }, [enableModelTypes, lang]);
  return (
    <RadioTagGroup
      options={options}
      title={`${translate(Editor_Words["choose-a-model"], lang)}：`}
      className={classNames(className, block())}
      flexDirection={direction}
      useRadioGroupProps={{
        value: value,
        onChange: onChange,
      }}
    />
  );
};

export const PresetSwitch = chakra(observer(IPresetSwitch));
